import { MutableState, Mutator, Tools } from 'final-form';

const unset: Mutator<any> = (
    [fields]: [string[]],
    state: MutableState<any>,
    { changeValue }: Tools<any>
) => {
    fields.forEach((field) => {
        changeValue(state, field, (oldValue: any) => undefined);
    });
};

export default unset;
